import React from "react";
import ConfirmDeleteModal from "../../../Layout/Components/ConfirmDeleteModal";

const ConfirmRemovalModal = ({ label, isOpen, toggle, handleDelete, row }) => {
  return (
    <ConfirmDeleteModal
      title={label}
      isOpen={isOpen}
      toggle={toggle}
      handleDelete={() => (row ? handleDelete(row) : handleDelete())}
    />
  );
};

export default ConfirmRemovalModal;
